import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import ElementUI from 'element-ui'
import 'normalize.css'

// 加载组件
// eslint-disable-next-line import/no-cycle
import ajax from '@/assets/js/request'

// 应用配置加载
import App from './App'
// eslint-disable-next-line import/no-cycle
import stores from './store'
import routes from './router'
// eslint-disable-next-line import/no-cycle
import routerEach from './router/each'

// 载入应用层
Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(ElementUI)
Vue.prototype.$Ajax = ajax

// 全局存储配置
const store = new Vuex.Store(stores)

// 全局路由配置
const router = new VueRouter(routes)
router.beforeEach((to, from, next) => routerEach.beforeEach(router, to, from, next))
router.beforeEach((to, from, next) => routerEach.beforeEachCheck(router, to, from, next))
router.afterEach(() => routerEach.afterEach(router))

export default new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js